import Vue from 'vue';
import warehouseReportTransformer from './../../transformers/warehouseReport';

const success = ({ data }, resolve) => {
  const report = warehouseReportTransformer.fetchCollection(data.data);

  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (warehouseId = null, limit = null) => (
  new Promise((resolve, reject) => {
    let url = '/reports/warehouses';
    const query = [];

    if (limit) {
      query.push(`limit=${limit}`);
    }

    if (warehouseId && warehouseId !== '') {
      query.push(`warehouse_id=${warehouseId}`);
    }

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/warehouses.js